import { Box, Grid, Stack, Typography } from "@mui/material";
import { Flex } from "components/atoms/Flex";
import React, { memo } from "react";

export const ContactInfo = memo(function (): JSX.Element {
  return (
    <Box
      p={3}
      pt={5}
      sx={{
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography variant="h2" fontWeight="bold" textAlign="center" padding={2}>
        Call Us
      </Typography>
      <Grid container spacing={2} sx={{ marginTop: 1, padding: 2 }}>
        <Grid size={{
            xs: 12,
            md: 4,
        }} offset={{
            xs: 0,
            md: 2,
        }} gap={2}>
          <Stack paddingY={2} rowGap={1}>
            <Typography fontWeight="bold">
              24/7 ACCESS On-Demand Concierge
            </Typography>
            <Typography>1-833-242-2223 (TTY 711) </Typography>
          </Stack>
          <Stack  paddingY={2} rowGap={1}>
            <Typography fontWeight="bold">Member Services</Typography>
            <Typography>
              English: 1 (866) 634-2247 (TTY 711)
              <br />
              Spanish: 1 (877) 399-2247
              <br />
              8am - 8pm, 7 days a week (excluding Thanksgiving and Christmas)
              Oct. 1 - March 31
              <br />
              8am - 8pm, Monday to Friday (excluding holidays)
              <br />
              April 1 - Sept. 30
            </Typography>
          </Stack>
        </Grid>
        <Grid size={{
            xs: 12,
            md: 4,
        }} gap={2}>
          <Stack paddingY={2} rowGap={1}>
            <Typography fontWeight="bold">Member Pharmacy Help</Typography>
            <Typography>
              Get 24/7 answers about your prescription drug benefits and copays
              <br />1 (844) 227-7616 (TTY 711)
            </Typography>
          </Stack>
          <Stack paddingY={2} rowGap={1}>
            <Typography fontWeight="bold">Pharmacy Technical Help</Typography>
            <Typography>
              Resolve prescription claims and billing issues 24/7
              <br />1 (844) 227-7615
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
});

export default ContactInfo;
